import { Router } from "@frui.ts/screens/dist";
import type BankAccountBlacklist from "entities/bankAccountBlacklist";
import BankAccountBlacklistRepository from "repositories/bankAccountBlacklistRepository";
import EventBus, { blacklistedAccountsChanged } from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import SecurityService from "services/securityService";
import { Modules } from "config";
import ConfirmationService from "../../../services/confirmationService";
import ListViewModel from "../../listViewModel";
import BankAccountBlacklistCreateViewModel from "./bankAccountBlacklistCreateViewModel";
import BankAccountBlacklistDetailViewModel from "./bankAccountBlacklistDetailViewModel";

const navigationName = "bank-account-blacklists";

@Router.registerRoute({
  route: navigationName,
  name: Router.Self,
  children: [BankAccountBlacklistDetailViewModel, BankAccountBlacklistCreateViewModel],
})
export default class BankAccountBlacklistsViewModel extends ListViewModel<
  BankAccountBlacklist,
  BankAccountBlacklistDetailViewModel,
  BankAccountBlacklistCreateViewModel
> {
  readonly modelName = "bankAccountBlacklist";

  constructor(
    protected createViewModelFactory: () => BankAccountBlacklistCreateViewModel,
    protected detailViewModelFactory: ReturnType<typeof BankAccountBlacklistDetailViewModel.Factory>,
    protected repository: BankAccountBlacklistRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected securityService: SecurityService,
    protected eventBus: EventBus,
    protected confirmationService: ConfirmationService
  ) {
    super();
    this.navigationName = navigationName;
  }

  protected onDeleted(item: BankAccountBlacklist) {
    super.onDeleted(item);
    this.eventBus.publish(
      blacklistedAccountsChanged({ bankAccount: { accountNumber: item.bankAccount.accountNumber, bank: item.bankAccount.bank } })
    );
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.finance, `bankAccountBlacklists.${code}`, size);
  }
}
